import classes from './SwitchToDesktop.module.scss';

// assets
import metamaskLogo from 'assets/metamask.png';

export default function MetamaskNotAvailable() {
  return (
    <div className={classes.root}>
      <div className={classes.overlay}>
        <img src={metamaskLogo} alt="Metamask Logo" style={{height:"129px"}} />
        <p className={classes.text}>Please switch to a desktop device.</p>
      </div>
    </div>
  );
}
